import { FC, Fragment, Suspense, useRef, useState } from 'react';
import { TieredMenu } from 'primereact/tieredmenu';
import { MeterOption } from '../../models/MeterOption';
import { Tooltip } from 'primereact/tooltip';
import { StudentsModal } from './StudentsModal';
import { FilterOptionValues } from './TeacherDashboard';

interface Props {
  value: MeterOption;
  filterOption: FilterOptionValues;
}

export const MeterTemplateWeekly: FC<Props> = ({ value, filterOption }) => {
  const menuRef = useRef<TieredMenu>(null);
  const [passed, setPassed] = useState<number | null | undefined>(undefined);
  const [modalVisible, setModalVisible] = useState(false);
  const [label, setLabel] = useState('');
  return (
    <Fragment>
      <Tooltip className="tw-font-atkinson" target={`.${value.className}`} mouseTrack position="top" />
      <button
        data-pr-tooltip={[
          `${value.students} Students`,
          value.passed === 0 && 'No new skills passed',
          value.passed === null && 'No skill challenges attempted',
        ]
          .filter(Boolean)
          .join(' - ')}
        className={`${value.className} bar-md text-center border-none cursor-pointer ${
          value.label === '3' ? 'text-0' : 'text-900'
        }`}
        style={{
          width: `${value.width}%`,
          minWidth: '7%',
          padding: `${value.width < 10 && '0'}`,
          marginLeft: value.passed !== null && value.index !== 0 ? 2 : 0,
          fontFamily: 'Poppins',
        }}
        onClick={e => {
          if (value.passed !== undefined) {
            setPassed(value.passed);
            setLabel(`${value.label}${value.passed && value.passed > 2 ? '+' : ''} `);
            setModalVisible(true);
          }

          menuRef.current?.toggle(e);
        }}
      >
        {`${value.label}${value.passed && value.passed > 2 ? '+' : ''} `}
      </button>
      {modalVisible && (
        <Suspense>
          <StudentsModal
            filterOption={filterOption}
            visible={modalVisible}
            setModalVisible={setModalVisible}
            header="Weekly Snapshot"
            label={label}
            score={passed}
            type="week"
          />
        </Suspense>
      )}
    </Fragment>
  );
};
